"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUNDDOWN = void 0;
exports.ROUNDDOWN = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:ROUNDDOWN not implemented');
    },
};
//# sourceMappingURL=rounddown.js.map